import { useContext } from 'react';
import { UserContext } from '../../App';
import { FileManager } from './common/file-manager/file-manager';

export default function Documents() {
    const { userProfile } = useContext(UserContext);

    // Check if user is admin
    const isAdmin = userProfile.role.filter((r: any) => r.id === 'padeltech_administrator').length > 0;

    // Determine user role for file manager
    const getUserRole = () => {
        if (isAdmin) {
            return 'manager'; // Admin has full access like manager
        }
        if (userProfile.role.filter((r: any) => r.id === 'padeltech_manager').length > 0) {
            return 'manager';
        }
        if (userProfile.role.filter((r: any) => r.id === 'padeltech_coach').length > 0) {
            return 'coach';
        }
        if (userProfile.role.filter((r: any) => r.id === 'padeltech_athlete').length > 0) {
            return 'athlete';
        }
        return 'athlete'; // Default to read-only
    };

    return (
        <FileManager userRole={getUserRole()} isAdmin={isAdmin} />
    );
}
